export const normalizeFormErrors = errors => {
	let res = {}

	Object.keys(errors).forEach(function(key, index) {
		let value = this[key][0]
		let label = errorLabel(key)
		if (label !== null) {
			res[label] = value
		}
		else if(process.env.REACT_APP_STAGING || process.env.NODE_ENV === "development"){
			console.log("%cunknown error :", "font-size: 2em;color:red;", key)
		}
	}, errors)

	return res
}

const errorLabel = key => {
	switch (key) {
		case "person.account.email":
		case "person.email":
			return "email"
		case "person.first_name":
			return "first_name"
		case "person.last_name":
			return "last_name"
		case "telephone":
			return "telephone"
		case "secondary_phone":
			return "secondary_phone"
		case "landline_phone":
			return "landline_phone"
		case "person.account.password":
		case "password":
			return "password"
		case "person.account.old_password":
		case "old_password":
			return "old_password"
		case "person.account.password_confirmation":
			return "password_confirmation"
		case "sodexo_reference":
			return "sodexo_reference"
		case "address.street_name":
			return "address_street"
		case "address.town":
			return "address_town"
		case "address.street_number":
			return "address_street_number"
		case "address.zip_code":
			return "address_zip_code"
		case "address.surface":
		case "surface":
			return "address_surface"
		case "address.extra_info":
			return "address_extra_info"
		default:
			return null
	}
}


// WEBPACK FOOTER //
// ./src/normalizers/FormErrorsNormalizer.js